/**
 * Categories actions.
 * @module actions/categories/categories
 */

import { GET_RECIPE_CATEGORIES } from '../../constants/ActionTypes';

/**
 * Get categories items.
 * @function getCategories
 * @param {string} category Category
 * @param {string} type Type
 * @returns {Object} Categories action.
 */
export default function getRecipeCategories(category, fetchAll) {
  let all = fetchAll ? 'all=1' : '';
  return {
    type: GET_RECIPE_CATEGORIES,
    request: {
      op: 'get',
      path: `/@categories${
        !!parseInt(category) ? `/${category}` : ''
      }?type=recipes&${all}`,
    },
  };
}
